export default __webpack_public_path__ + "static/media/origino_logo_full_landscape.8702e27f.jpg";